module.exports = __webpack_public_path__ + "media/packs/landing_page/images/Spotify-222e87aa0d0bc3530b4104a1ff94ec39.png";